import "../styles/genAIJobRoles.css";
import {
  FaChartBar,
  FaDatabase,
  FaLaptopCode,
  FaChartLine,
  FaFileAlt
} from "react-icons/fa";

export default function PowerBIJobRoles() {
  const roles = [
    { title: "Data Analyst", icon: <FaChartBar /> },
    { title: "Power BI Developer", icon: <FaLaptopCode /> },
    { title: "Business Intelligence (BI) Analyst", icon: <FaDatabase /> },
    { title: "Reporting Analyst", icon: <FaFileAlt /> },
    { title: "Data Visualization Specialist", icon: <FaChartLine /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">

        {/* HEADER */}
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>
            Career opportunities after completing the
            <strong> Power BI Data Analyst Program</strong>
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}